module.exports = __webpack_public_path__ + "img/tablet-neck-9_146x18.e115ca6f.png";